import { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { resolveCtaUrl, fileUrl } from "../../lib/cta";

const navLinks = [
  { label: "Para Quem", id: "audience" },
  { label: "Método", id: "method" },
  { label: "Galeria", id: "gallery" },
  { label: "Sobre", id: "about" },
  { label: "FAQ", id: "faq" },
];

export default function Navbar({ brand, whatsapp, content }) {
  const [open, setOpen] = useState(false);

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  const ctaHref = resolveCtaUrl(content);
  const logoUrl = fileUrl(brand?.logo);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="sticky top-0 z-40 backdrop-blur-md bg-alabaster/80 border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="navbar-brand"
          onClick={() => handleScroll("hero")}
          className="flex items-center gap-3 font-serif text-xl tracking-tight"
        >
          {logoUrl && (
            <img
              data-testid="navbar-logo"
              src={logoUrl}
              alt={brand.name}
              className="w-10 h-10 object-cover rounded-sm"
            />
          )}
          <span>{brand.name}</span>
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => handleScroll(l.id)}
              className="text-sm tracking-wide text-onyx/70 hover:text-onyx transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="navbar-cta"
            href={ctaHref}
            target="_blank"
            rel="noreferrer"
            className="text-xs tracking-[0.2em] uppercase font-semibold px-5 py-2.5 border border-onyx bg-onyx text-alabaster hover:bg-transparent hover:text-onyx transition-all"
          >
            Fale Comigo
          </a>
        </nav>
        <button
          data-testid="navbar-toggle"
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="navbar-mobile-menu" className="md:hidden border-t border-border bg-alabaster">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => handleScroll(l.id)}
                className="text-left py-2 text-onyx/80"
              >
                {l.label}
              </button>
            ))}
            <a
              href={ctaHref}
              target="_blank"
              rel="noreferrer"
              className="mt-2 text-center text-xs tracking-[0.2em] uppercase font-semibold px-5 py-3 bg-onyx text-alabaster"
            >
              Fale Comigo
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
